import axiosApi from "api/root.api";

export const currentInfo = async () => {
  const urlEnd = "/platform/account/v1/current";
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
